import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = guest

  useEffect(() => {
    if (!localStorage.getItem("serenity_token")) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("serenity_token", data.access_token);
    localStorage.setItem("serenity_refresh", data.refresh_token);
    // default the admin brand view to the user's own brand (super-admins can switch later)
    localStorage.setItem("admin_brand", data.user?.brand || "clinic");
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("serenity_token");
    localStorage.removeItem("serenity_refresh");
    localStorage.removeItem("admin_brand");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
